









import { Component, Vue } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import Event from '@/models/event'
import { Actions } from '@/util/vuex-types'
import EventCard from '@/components/EventCard.vue'

@Component({
    components: {
        EventCard,
    },
})
export default class UpcomingEvents extends Vue {

    @State upcomingEvents?: Event[]
    @Action [Actions.FETCH_EVENTS]: any

    async mounted() {
        if (this.upcomingEvents == null || this.upcomingEvents.length === 0) {
            await this.fetchEvents(await this.$auth.getAccessToken())
        }
    }
}
